import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { IFormBuilder } from '../IFormBuilder';
import { TransportItem } from '../../transport-item.model';
import { FormControl, ValidatorFn } from '@angular/forms';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { OfferMerchandiseTypeEnum } from '../../enums/offer-merchandise-type.enum';
import { IPricingTransporterConfiguration } from '../../pricing-transporter.configuration';

interface ITransportItemFormBuilder extends IFormBuilder<TransportItemControls> {
  init(config: IPricingTransporterConfiguration): ITransportItemFormBuilder;

  build(): IGenericBaryFormGroup<TransportItemControls>;
}

export type TransportItemControls = {
  id: FormControl;
  handlingType: FormControl;
  dimension: FormControl;
  length: FormControl;
  width: FormControl;
  maxHeight: FormControl;
  weight: FormControl;
  volume: FormControl;
  quantity: FormControl;
  groundPalletQuantity: FormControl;
  otherSpecificQuantity: FormControl;
  description: FormControl;
  other: FormControl;
  vehicleCategory: FormControl;
  vehicleType: FormControl;
  vehicleNotFound: FormControl;
  transport: FormControl;
};

export class TransportItemFormBuilder implements ITransportItemFormBuilder {
  private formName = 'transportForm';
  private controls!: TransportItemControls;
  private validators?: ValidatorFn[];

  constructor(private bcf: BaryFormFactoryService) {}

  public init(
    config: IPricingTransporterConfiguration,
    transportItem?: TransportItem,
    merchandiseType: OfferMerchandiseTypeEnum = OfferMerchandiseTypeEnum.CONDITIONED
  ): TransportItemFormBuilder {
    this.controls = this.bcf.makeTransportItemControls(config, transportItem, merchandiseType);
    this.applyTransporterConfiguration();
    return this;
  }

  private applyTransporterConfiguration(): void {
    this.validators = [];
  }

  build(): IGenericBaryFormGroup<TransportItemControls> {
    return new GenericBaryFormGroup<TransportItemControls>(this.formName, this.controls!, this.validators);
  }
}
